'use client';
import type {} from 'ldrs';
import { type PropsWithChildren, useEffect, useState } from 'react';
import NewtonsCradleLoading from '@/components/Loaders/LineSpinner';
import { ThemeProvider } from '@/components/ui/theme-provider';
import '@/assets/styles/globals.css';

const Provider = (props: PropsWithChildren) => {
    const { children } = props;
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        async function getLoader() {
            const { newtonsCradle } = await import('ldrs');
            newtonsCradle.register();
        }
        getLoader();
        setIsClient(true);
    }, []);

    if (!isClient) return <FullScLoading />;
    return (
        <ThemeProvider attribute='class' defaultTheme='dark' themes={['light', 'dark']}>
            {children}
        </ThemeProvider>
    );
};

export default Provider;

export const FullScLoading = () => {
    return (
        <div
            className={`dark fixed inset-0 z-50 flex h-full min-h-screen w-full items-center justify-center !bg-background`}>
            <NewtonsCradleLoading size='100' color='white' speed='1.4' />
        </div>
    );
};
